import { render } from "./VZDeleteModal.vue?vue&type=template&id=25581a14&ts=true"
import script from "./VZDeleteModal.vue?vue&type=script&lang=ts"
export * from "./VZDeleteModal.vue?vue&type=script&lang=ts"

import "./VZDeleteModal.vue?vue&type=style&index=0&id=25581a14&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__